module.exports = __webpack_public_path__ + "static/media/nicole sigonly.b258322a.png";